<template>
  <div>
    <van-dialog v-model="showCust" class="cust" width="97%" style="height: 80%;overflow: scroll;" :beforeClose="beforeClose" :showConfirmButton = 'false' :close-on-click-overlay="true">
      <template slot="title">
        <div class="dialog_title">
          <van-button type="info" size="small" plain @click="addCustomer">+添加客户</van-button>
          <span>选择客户</span>
        </div>
      </template>
      <van-search
        v-model="searchValue"
        show-action
        placeholder="请输入客户名称搜索"
        @search="onSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <van-list class="van-list" v-model="loading" style="height: 80%" :finished="finished" finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
        <van-cell v-for="(item,index) in list" :key="index" @click="selectCust(item)">
          <div class="flex-between">
            <div>
              <div class="custName-wrap"> <div class="custName"> {{ item.custName }} </div> </div>
              <div>
                <!-- <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" v-if="item.custType">{{ formatHandel("custType",item.custType) }}</van-tag>
                <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" v-if="item.custSource">{{ formatHandel("custSource",item.custSource) }}</van-tag>
                <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" v-if="item.custStatus">{{ formatHandel("custStatus",item.custStatus) }}</van-tag> -->
                <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.custLevel">{{ formatHandel("custLevel", item.custLevel) }}</van-tag>   <!---客户等级-->
                <!---客户来源-->
                <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.industry" >{{ item.industry }}</van-tag><!--所属行业-->
                <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.unitNature">{{ formatHandel("unitNature", item.unitNature) }}</van-tag >  <!--单位性质-->
              </div>
            </div>
          </div>
        </van-cell>
      </van-list>
      <empty-component v-if="isEmpty" />
    </van-dialog>
  </div>
</template>

<script>
import { listCust } from '@/api/scrm/mycust'
// import { getDicts } from '@/api/system/dict/data'
import { Toast } from 'vant'
import EmptyComponent from '@/components/common/Empty'
export default {
  name: 'SelectCustomer',
  components: {
    EmptyComponent
  },
  props: {
    show: Boolean
  },
  watch: {
    show: {
      handler(val, oldVal) {
        this.showCust = val
        if (val) {
          this.handleList()
        }
      }
    }
  },
  data() {
    return {
      showCust: false,
      isEmpty: false,
      loading: false,
      finished: false,
      total: 0,
      searchValue: '',
      list: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      form: {},
      options: {
        // 客户类型字典
        custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
        // 客户来源字典
        custSourceOptions: this.$store.state.dictOptions.custSource || [],
        // 客户状态
        custStatusOptions: this.$store.state.dictOptions.custStatus || [],
        custLevelOptions: [],
        unitNatureOptions: []
      }
    }
  },
  created() {
    // 客户等级
    this.getDicts('crm_cust_level').then(res => {
      this.options.custLevelOptions = res.data
    })
    // 单位性质
    this.getDicts('crm_unit_nature').then(res => {
      this.options.unitNatureOptions = res.data
    })
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      // document.title = '客户管理-我的客户'
    },
    addCustomer() {
      this.$router.push({
        path: '/scrm/myCust/add',
        query: { from: 'contract' }
      })
    },
    QueryReset() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    },
    // 搜索子组件传递过来的搜索关键字
    onSearch() {
      this.isEmpty = false
      this.QueryReset()
      this.queryParams.custName = this.searchValue
      this.queryCustList()
    },
    // // 过滤子组件传递过来的搜索对象
    // handleFqueryFilter(data) {
    //   this.isEmpty = false;
    //   let query = this.queryParams;
    //   this.queryParams = { ...query, ...data }
    //   this.queryCustList()
    // },
    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.handleList()
    },
    async handleList() {
      // console.log('23333')
      this.loading = true
      const res = await listCust(this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        }
        this.list = this.list.concat(...res.rows)
        console.log(this.list)
        this.total = res.total
        this.queryParams.pageNum += 1
        this.loading = false
        this.finished = this.list.length >= res.total
      }
    },
    formatHandel(type, value) {
      const optionItem = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[optionItem], value)
      } else {
        return ''
      }
    },
    selectCust(item) {
      if (!item.unitNature || !item.custLevel || !item.industryCode) {
        Toast.fail('请先完善客户信息')
        setTimeout(() => {
          this.$router.push('/scrm/myCust/modifyInfos?custId=' + item.custId)
        }, 500)
        return
      }
      this.form.custId = item.custId
      this.form.custName = item.custName
      this.form.custSource = item.custSource
      this.showCust = false
      this.$emit('beforeClose', this.form)
    },
    beforeClose() {
      // console.log(this.form)
      this.$emit('handleCancel')
    },
    onLoad() {
      this.handleList()
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-list{
  margin-top: -120px;
}
.cust /deep/.van-dialog__content {
  height: 80%;
}
.dialog_title{
  width: 66%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .van-button{
    border-radius: 10px;
  }
}
</style>
